<template>
  <div class="basic_wrap">
    <bsHeader title="他人代付" />
    <div class="agency_page">
      <div class="agency_card">
        <div class="card_head">
          <span class="card_title">他人代付</span>
          <span class="status_tag">{{ generated ? "已生成" : "待支付" }}</span>
        </div>
        <p class="amount_text">¥{{ formatPrice(payData.actual_money) }}</p>
        <p class="amount_tip">实际金额以付款人确认付款时为准</p>
        <div class="trade_info">
          <p class="trade_label">担保交易</p>
          <p class="trade_name van-multi-ellipsis--l2">{{ goodsSummary }}</p>
        </div>
      </div>

      <div class="order_info" v-if="generated">
        <div class="info_row">
          <span class="info_label">代付订单</span>
          <span class="info_value">{{ orderNosText }}</span>
        </div>
      </div>

      <div class="action_group">
        <button class="primary_btn" :disabled="submitting" @click="generateAgencyOrder">
          {{ submitting ? "处理中..." : generated ? "重新复制代付信息" : "生成代付订单" }}
        </button>
        <button class="secondary_btn" :disabled="submitting" @click="shareWithAlipayFriend">
          找支付宝好友帮忙付
        </button>
      </div>

      <div class="share_panel">
        <p class="share_title">通过其他方式找朋友帮忙付</p>
        <div class="share_list">
          <div class="share_item" @click="handleShare('微信')">
            <span class="share_icon wechat">W</span>
            <span class="share_name">微信</span>
          </div>
          <div class="share_item" @click="handleShare('QQ')">
            <span class="share_icon qq">Q</span>
            <span class="share_name">QQ</span>
          </div>
          <div class="share_item" @click="handleShare('支付宝')">
            <span class="share_icon alipay">A</span>
            <span class="share_name">支付宝</span>
          </div>
          <div class="share_item" @click="copyShareText()">
            <span class="share_icon link">L</span>
            <span class="share_name">生成链接</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Fetch from "../../utils/fetch";
import bsHeader from "../../components/bsHeader.vue";

export default {
  name: "AgencyPay",
  components: {
    bsHeader
  },
  data() {
    return {
      submitting: false,
      generated: false,
      orderNos: [],
      payData: {
        user_money: 0,
        actual_money: 0,
        item_num: 0,
        item_list: [],
        buyer_remark: "",
        address: null
      }
    };
  },
  computed: {
    goodsSummary() {
      if (!this.payData.item_list.length) {
        return "暂无商品";
      }
      if (this.payData.item_list.length === 1) {
        return this.payData.item_list[0].title || "担保交易";
      }
      return this.payData.item_list[0].title + "等" + this.payData.item_list.length + "件商品";
    },
    orderNosText() {
      return this.orderNos.length ? this.orderNos.join("、") : "--";
    },
    shareText() {
      var lines = [
        "请帮我代付订单",
        "商品：" + this.goodsSummary,
        "金额：¥" + this.formatPrice(this.payData.actual_money)
      ];
      if (this.orderNos.length) {
        lines.push("订单号：" + this.orderNos.join("、"));
      }
      return lines.join("\n");
    }
  },
  created() {
    this.$parent.footer("item", false);
  },
  mounted() {
    this.loadPayData();
  },
  methods: {
    formatPrice(value) {
      var num = parseFloat(value) || 0;
      return num.toFixed(2);
    },
    loadPayData() {
      var payJson = localStorage.getItem("shop_pay_confirm");
      if (!payJson) {
        this.$toast("订单信息已失效");
        this.$router.replace("/cart");
        return;
      }
      try {
        this.payData = JSON.parse(payJson) || this.payData;
      } catch (error) {
        this.$toast("订单信息异常");
        this.$router.replace("/cart");
      }
    },
    buildOrderParams() {
      var items = this.payData.item_list.map(item => {
        return {
          item_id: item.item_id,
          quantity: item.number
        };
      });
      var params = {
        pay_type: "agency",
        items_json: JSON.stringify(items),
        buyer_remark: this.payData.buyer_remark || ""
      };
      if (this.payData.address) {
        params.customer_name = this.payData.address.customer_name || "";
        params.customer_tel = this.payData.address.customer_tel || "";
        params.province = this.payData.address.province || "";
        params.city = this.payData.address.city || "";
        params.county = this.payData.address.county || "";
        params.address = this.payData.address.address || "";
      }
      return params;
    },
    ensureAgencyOrder() {
      if (this.generated) {
        return Promise.resolve({
          data: {
            order_nos: this.orderNos
          }
        });
      }
      if (this.submitting) {
        return Promise.reject("");
      }
      if (!this.payData.item_list.length) {
        this.$toast("暂无可支付商品");
        return Promise.reject("");
      }
      this.submitting = true;
      return Fetch("/shop/batch_order_create", this.buildOrderParams()).then(res => {
        var data = res.data || {};
        this.orderNos = data.order_nos || [];
        this.generated = true;
        localStorage.removeItem("cart");
        localStorage.removeItem("shop_pay_confirm");
        return res;
      }).finally(() => {
        this.submitting = false;
      });
    },
    generateAgencyOrder() {
      var isNewOrder = !this.generated;
      this.ensureAgencyOrder().then(() => {
        var targetItem = this.payData.item_list && this.payData.item_list.length
          ? this.payData.item_list[0]
          : null;
        var targetUrl = targetItem && targetItem.item_id
          ? "/details/" + targetItem.item_id
          : "/item";
        var that = this;
        this.$toast({
          message: isNewOrder ? "下单成功" : "代付订单已生成",
          duration: 1200,
          onClose: function () {
            that.$router.replace(targetUrl);
          }
        });
      }).catch(() => {});
    },
    simulateShareFailure(message) {
      if (this.submitting) {
        return;
      }
      this.submitting = true;
      setTimeout(() => {
        this.submitting = false;
        this.$toast(message || "分享发起失败，请稍后重试");
      }, 1500);
    },
    shareWithAlipayFriend() {
      this.simulateShareFailure("拉起支付宝好友代付失败");
    },
    handleShare(label) {
      var messageMap = {
        "微信": "拉起微信分享失败",
        "QQ": "拉起QQ分享失败",
        "支付宝": "拉起支付宝分享失败"
      };
      this.simulateShareFailure(messageMap[label] || "分享发起失败，请稍后重试");
    },
    copyShareText() {
      this.simulateShareFailure("生成代付链接失败");
    }
  }
};
</script>

<style lang="less" scoped>
.basic_wrap {
  min-height: 100vh;
  background: #f5f5f5;
  padding-top: 44px;
}

.agency_page {
  min-height: calc(100vh - 44px);
  padding: 16px 14px 24px;
}

.agency_card {
  overflow: hidden;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.04);
}

.card_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 16px 0;
  background: linear-gradient(135deg, #ff9500 0%, #ff7e00 100%);
}

.card_title {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
}

.status_tag {
  min-width: 68px;
  padding: 6px 10px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.25);
  text-align: center;
  font-size: 13px;
  color: #ffffff;
}

.amount_text {
  margin: 0;
  padding-top: 18px;
  background: linear-gradient(135deg, #ff9500 0%, #ff7e00 100%);
  text-align: center;
  font-size: 28px;
  line-height: 40px;
  font-weight: 700;
  color: #ffffff;
}

.amount_tip {
  margin: 0;
  padding: 6px 16px 18px;
  background: linear-gradient(135deg, #ff9500 0%, #ff7e00 100%);
  text-align: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
}

.trade_info {
  padding: 18px 16px 20px;
}

.trade_label {
  margin: 0;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  color: #333333;
}

.trade_name {
  margin: 10px 0 0;
  font-size: 15px;
  line-height: 22px;
  color: #666666;
}

.order_info {
  margin-top: 14px;
  padding: 14px 16px;
  border-radius: 12px;
  background: #ffffff;
}

.info_row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.info_label {
  flex-shrink: 0;
  font-size: 14px;
  color: #666666;
}

.info_value {
  flex: 1;
  text-align: right;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  word-break: break-all;
}

.action_group {
  margin-top: 110px;
}

.primary_btn,
.secondary_btn {
  width: 100%;
  height: 46px;
  border: none;
  border-radius: 23px;
  font-size: 16px;
  font-weight: 600;
}

.primary_btn {
  background: linear-gradient(90deg, #ff4328 0%, #ff2d1e 100%);
  color: #ffffff;
}

.secondary_btn {
  margin-top: 14px;
  background: #ffffff;
  border: 1px solid #ff4c35;
  color: #ff4c35;
}

.primary_btn[disabled],
.secondary_btn[disabled] {
  opacity: 0.6;
}

.share_panel {
  margin-top: 12px;
  padding: 18px 16px 20px;
  border-radius: 14px;
  background: #ffffff;
}

.share_title {
  margin: 0;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  color: #666666;
}

.share_list {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.share_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 25%;
}

.share_icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
}

.share_name {
  margin-top: 10px;
  font-size: 13px;
  color: #666666;
}

.wechat {
  background: #46b549;
}

.qq {
  background: #25a4e8;
}

.alipay {
  background: #1497e6;
}

.link {
  background: #ff9800;
}
</style>
